import React from 'react';

const {
    hooks: {useBreakpoint}
} = polyphony;

const EditorControls = ({setProp, text, indent}) => {
    const {
        editor: {InspectorControls},
        components: {TextControl}
    } = window.wp;
    return (
        <InspectorControls>
            <TextControl label="Text" value={text} onChange={text => setProp('text', text)} />
            <TextControl label="Indent" value={indent} onChange={text => setProp('indent', text)} />
        </InspectorControls>
    );
};

const IndentedHeader = ({gutenberg:{isEditor, setProp}, text, indent}) => {
    const isMobile = useBreakpoint() === 'mobile';
    return <>
        {isEditor && <EditorControls setProp={setProp} text={text} indent={indent}/>}
        <div role="none">
            <h2 style={isMobile ? {} : {marginLeft: indent, fontWeight: 'bold'}}>{text}</h2>
        </div>
    </>;
};

IndentedHeader.title = "Indented Header";
IndentedHeader.icon = 'wp';
IndentedHeader.category = 'layout';

export default IndentedHeader;

